import { render } from "./headerCom.vue?vue&type=template&id=23194884&scoped=true"
const script = {}

import "./headerCom.vue?vue&type=style&index=0&id=23194884&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23194884"]])

export default __exports__